import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signout-confirmation-dialog',
  templateUrl: './signout-confirmation-dialog.component.html',
  styleUrls: ['./signout-confirmation-dialog.component.scss']
})
export class SignoutConfirmationDialogComponent implements OnInit {

  title: string = "Are you sure you want to close ?";
  checkStream:boolean;
  disConfirm:any;
  
  constructor(public dialogRef: MatDialogRef<SignoutConfirmationDialogComponent>,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) private data: any) {
      this.checkStream = data;
    // if (data.includes('original')) {
    //   this.disConfirm = data;
    // } else {
    //   this.checkStream = data;
    // }
  }

  ngOnInit() {
  }

  confirm(type): void {
    this.dialogRef.close(type);
  }

}
